<template>
  <div class="creekroad">
    <div class="heading">
      <h1>Provincetown &mdash; <i>Creek Road Conservation Area</i></h1>
      <h4><i>Conservation Protections in the Creek Road/West Vine Street Area of Provincetown</i></h4>
    </div>

    <div class="creekRoadConservationAreaMAP">
      <img src="../assets/images/CreekRoadAreaConservWet_1.png" class="img-fluid" alt="Wetlands">
    </div>

    <div class="creekRoadConservationAreaMAP_Mobile">
      <img src="../assets/images/CreekRoadAreaConservWetMobile_1.png" class="img-fluid" alt="Wetlands">
    </div>

    <Introduction></Introduction>

    <PropertyDetails></PropertyDetails>

    <Definitions></Definitions>

    <PtownConsvComm></PtownConsvComm>

    <Resources></Resources>

    <div class="footerSpacing">

    </div>

  </div>
</template>

<script>
  import Introduction from "@/components/CreekRoadCons/Introduction.vue"
  import PropertyDetails from "@/components/CreekRoadCons/PropertyDetails.vue"
  import PtownConsvComm from "@/components/CreekRoadCons/PtownConsvComm.vue"
  import Definitions from "@/components/CreekRoadCons/Definitions.vue"
  import Resources from "@/components/CreekRoadCons/Resources.vue"

  export default {
    data() {
      return {
        somedataelement: ''
      }
    },
    components: {
      Introduction,
      PropertyDetails,
      PtownConsvComm,
      Definitions,
      Resources
    },
    computed: {
      someFunction() {
        return 'someFunction'
      },
    },
    watch: {
      someWatchThing(value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      }
    },
    methods: {
      greet: function (event) {
        // `this` inside methods points to the Vue instance
        alert('Hello ' + this.name + '!')
        // `event` is the native DOM event
        if (event) {
          alert(event.target.tagName)
        }
      },

    }
  }
</script>

<style scoped>
  h2 {
    margin-top: 2rem;
  }

  h3 {
    margin-top: 1rem;
  }

  img {
    margin-bottom: 1rem;
  }

  li {
    margin: 10px 0;
  }

  .label-align {
    margin: 1em;
  }

  .heading {
    color: #fff;
    background-color: steelblue;
    padding: 1em;
  }

  .clearfix {
    overflow: auto;
  }

  .imgFloatRight {
    float: right;
    margin-left: 1rem;
  }

  figure {
    float: right;
    width: 50%;
    text-align: center;
    font-style: italic;
    font-size: smaller;
    text-indent: 0;
    border: thin silver solid;
    margin: 0.5em;
    padding: 0.5em;
  }

  /* img.scaled {
    width: 100%;
  } */

  .figure {
    float: left;
    width: 100%;
    text-align: center;
    font-style: italic;
    font-size: smaller;
    text-indent: 0;
    border: thin silver solid;
    margin: 0.5em;
    padding: 0.5em;
  }

  figCaption {
    margin-bottom: 1em;
  }

  .figureRight {
    float: right;
    width: 50%;
    text-align: center;
    font-style: italic;
    font-size: smaller;
    text-indent: 0;
    border: thin silver solid;
    margin: 0.5em;
    padding: 0.5em;
  }

  .figureLeft {
    float: left;
    width: 100%;
    text-align: center;
    font-style: italic;
    font-size: smaller;
    text-indent: 0;
    border: thin silver solid;
    margin: 0.5em;
    padding: 0.5em;
  }

  .imgFloatLeft {
    float: left;
    margin-right: 1rem;
  }

  .caption {
    font-size: small;
  }

  footer {
    margin-bottom: 1rem;
  }

  .green_area {
    background-color: white;
  }

  .card {
    margin-bottom: 1rem;
  }

  .hcard {
    margin-left: 1rem;
    font-size: .8rem;
  }

  .important-point {
    color: darkslateblue;
    font-weight: bold;
  }

  .quotation {
    margin-left: 1rem;
    margin-top: .5rem;
    font-style: italic;
    color: darkslategray;
  }

  /* .footnotes {
    margin-left: -1.5rem;
    font-size: .8rem;
    font-style: italic;
  } */

  .footnotes {
    display: block;
    font-style: italic;
    font-size: .8rem;
    border-width: 2px 0;
    border-style: solid;
    border-color: #eee;
    padding: 1em 0 0.5em;
    margin: 1em 0;
    position: relative;
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .footnotes:before {
    content: '';
    position: absolute;
    top: 0em;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    /* width: 3rem;
    height: 2rem; */
    color: #666;
    text-align: center;
  }

  .footnote-number {
    margin-top: -1rem;
    font-display: .8rem;
  }

  blockquote {
    display: block;
    font-style: italic;
    border-width: 2px 0;
    border-style: solid;
    border-color: #eee;
    padding: 1.5em 0 0.5em;
    margin: 1.5em 0;
    position: relative;
    margin-left: 2rem;
    margin-right: 2rem;
  }

  blockquote:before {
    content: '\201C';
    position: absolute;
    top: 0em;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 3rem;
    height: 2rem;
    font: 6em/1.08em 'PT Sans', sans-serif;
    color: #666;
    text-align: center;
  }

  blockquote:after {
    content: "\2013 \2003"attr(cite);
    display: block;
    text-align: right;
    font-size: 0.875em;
    color: #e74c3c;
  }

  /* https://stackoverflow.com/questions/27853884/media-queries-and-image-swapping/27853917 */

  .creekRoadConservationAreaMAP_Mobile {
    display: none;
  }

  @media only screen and (max-width: 768px) {

    .creekRoadConservationAreaMAP {
      display: none;
    }

    .creekRoadConservationAreaMAP_Mobile {
      display: block;
    }

  }

  /* .videoPlayer {
    width: 340px;
    height: auto;
  }

  .playPause {
    margin-top: 1rem;
  } */

  .footerSpacing {
    height: 2rem;
  }
</style>